import React from 'react';
import PageContainer from "../../../../hoc/PageContainer";
import './InternationalServices.css'

const InternationalServices = () =>
    (
        <div>
            <PageContainer page="ourServices"
            id="international-services-container">
                <h1 className="AboutUsTitle">Rotary Club of Central - 2012-2018 International Services</h1>
                <div className="our-services-video-container">
                    <iframe width="854" height="480" src="https://www.youtube.com/embed/A_iFV0ln0aU" frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen/>
                </div>
                <div className="AboutUsText">
                    <ul
                    id="international-services-list-item">
                        <li><b>Year 2012-2014 :</b> Rotary Club of Central X WorldVision – KUMMING / GUANZHOU SERVICE Trip</li>
                        <li><b>Year 2015 :</b> Rotary Club of Central X HKYSLA – Nepal Service Trip</li>
                        <li><b>Year 2017,2018 :</b> Rotary Club of Central X Rotary Club of Taipei Diamond – Mongolia Service trip ( Cooperate with Rotaract with Nairamdal )</li>
                    </ul>
                </div>

            </PageContainer>
        </div>
    );

export default InternationalServices;
